export default __webpack_public_path__ + "static/media/Black Dragon Claw.aefd1b3c.jpg";